var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.188 10.856V9.78c0-3.495-1.864-6.724-4.89-8.47-3.027-1.748-6.754-1.748-9.78 0-3.027 1.746-4.89 4.975-4.89 8.47v1.075C.831 11.469-.257 13.289.051 15.16c.308 1.87 1.925 3.245 3.822 3.249h.87c.177 0 .35-.071.475-.197.126-.126.197-.297.197-.475v-6.408c0-.178-.07-.349-.197-.475-.126-.126-.298-.197-.475-.197h-.773v-.876c0-3.015 1.608-5.8 4.218-7.307 2.61-1.506 5.826-1.506 8.437 0 2.61 1.507 4.218 4.292 4.218 7.307v.876h-.773c-.37 0-.672.301-.672.672v6.418c.003.251.146.48.37.595-.526.94-1.227 1.77-2.063 2.45-.44-.872-1.339-1.416-2.315-1.399h-1.088c-1.416.002-2.563 1.149-2.567 2.563v1.207c-.003.029-.003.056 0 .084-.003.027-.003.053 0 .081 0 .178.07.35.196.475.127.126.297.197.476.197 1.854-.003 3.67-.532 5.235-1.525 1.566-.995 2.817-2.412 3.608-4.09 1.833-.147 3.311-1.562 3.538-3.386.227-1.825-.86-3.558-2.601-4.15v.007zM4.072 12.002v5.074h-.198c-1.402 0-2.537-1.137-2.537-2.537 0-1.402 1.135-2.537 2.537-2.537h.198zm9.008 10.626v-.672c.001-.673.548-1.219 1.223-1.219h1.088c.536-.031 1.022.307 1.18.82-1.071.61-2.263.976-3.491 1.072zm7.861-5.563h-.198V12h.198c1.402 0 2.537 1.136 2.537 2.538 0 1.4-1.135 2.536-2.537 2.536v-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41B5C2",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M4.007 12.001v5.04c-1.68-.42-2.52-.84-2.519-2.673.002-1.834.839-1.947 2.519-2.367zM20.808 12.001v5.04c1.68-.42 2.521-.84 2.52-2.673-.002-1.834-.84-1.947-2.52-2.367zM12.828 22.921l3.78-1.26c-.84-.84-.758-1.114-2.1-.84-1.342.274-1.68.84-1.68 2.1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H24.819V24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contact-info.975ad24f8f03155aad61037b0136b6a7.svg";
export { ForwardRef as ReactComponent };